/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UpdateStrategySkillsRequestSkillsInner } from './';
import {
    UpdateStrategySkillsRequestSkillsInnerFromJSON,
    UpdateStrategySkillsRequestSkillsInnerFromJSONTyped,
    UpdateStrategySkillsRequestSkillsInnerToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateStrategySkillsRequest
 */
export interface UpdateStrategySkillsRequest {
    /**
     * 
     * @type {Array<UpdateStrategySkillsRequestSkillsInner>}
     * @memberof UpdateStrategySkillsRequest
     */
    skills: Array<UpdateStrategySkillsRequestSkillsInner>;
}

/**
 * Check if a given object implements the UpdateStrategySkillsRequest interface.
 */
export function instanceOfUpdateStrategySkillsRequest(value: object): value is UpdateStrategySkillsRequest {
    if (!('skills' in value) || value['skills'] === undefined) return false;
    return true;
}

export function UpdateStrategySkillsRequestFromJSON(json: any): UpdateStrategySkillsRequest {
    return UpdateStrategySkillsRequestFromJSONTyped(json, false);
}

export function UpdateStrategySkillsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateStrategySkillsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'skills': ((json['skills'] as Array<any>).map(UpdateStrategySkillsRequestSkillsInnerFromJSON)),
    };
}

export function UpdateStrategySkillsRequestToJSON(value?: UpdateStrategySkillsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'skills': ((value['skills'] as Array<any>).map((v) => UpdateStrategySkillsRequestSkillsInnerToJSON(v))),
    };
}

